import { useState } from "react";

export function PasswordGate({ onAuthenticated }: { onAuthenticated: () => void }) {
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError("");
    const res = await fetch("/api/auth", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ password }),
    });
    const data = await res.json();
    if (data.ok) {
      onAuthenticated();
    } else {
      setError("Incorrect password");
    }
  }

  return (
    <div className="min-h-screen bg-background flex flex-col items-center justify-center p-8">
      <h1 className="font-display text-4xl text-foreground mb-2">Jamie & Andrew</h1>
      <p className="font-body text-muted-foreground mb-8">Please enter the password to view the site</p>
      <form onSubmit={handleSubmit} className="w-full max-w-sm space-y-4">
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Password"
          className="w-full rounded-lg border border-input bg-background px-4 py-2 text-foreground placeholder:text-muted-foreground"
        />
        {error && <p className="text-destructive text-sm">{error}</p>}
        <button type="submit" className="w-full rounded-lg bg-primary text-primary-foreground px-4 py-2 font-body hover:bg-primary/90 transition-colors cursor-pointer">Enter</button>
      </form>
    </div>
  );
}
